import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './src/App.tsx';
import './src/index.css';
import { ToastProvider } from './src/components/Toast.tsx';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);